<script setup>
  import { ref, onMounted, computed } from 'vue'
  import { useRouter, useRoute } from 'vue-router'
  import Header from '@/components/Header.vue'
  import Footer from '@/components/Footer.vue'
  import DataTable from '@/components/DataTable.vue'
  import EditDialog from '@/components/EditDialog.vue'
  import { useDialogStore } from '@/stores/dialogStore'
  import { useTodoMasterStore } from '@/stores/todoMasterStore'

  const router = useRouter()
  const route = useRoute()

  const dialogStore = useDialogStore()
  const todoMasterStore = useTodoMasterStore()

  const breadcrumbs = ref([])

  // data ///////////////////////////////////////////
  const searchText = ref('')
  const sortKey = ref('')
  const sortDesc = ref(false)
  const length = ref('')

  // 案件ステータス選択用
  const selectedStatusId = ref('')

  // computed ///////////////////////////////////////

  // methods ////////////////////////////////////////
  onMounted(async () => {
    // パンくずリストを設定
    setupBreadcrumbs()

    // 案件マスタ一覧の取得
    await todoMasterStore.getTodoMasters()

    todoMasterStore.initTableList()
  })

  // パンくずリストを設定する関数
  const setupBreadcrumbs = () => {
    // 基本のパンくずリスト項目
    const baseBreadcrumbs = [
      { name: 'ダッシュボード', url: '/dashboard' },
      { name: '案件進捗一覧', url: '/todo' },
      { name: '案件マスタ一覧', url: '' },
    ]

    // breadcrumbsを更新
    breadcrumbs.value = baseBreadcrumbs
  }

  // 案件編集画面に遷移
  const editTodoMaster = item => {
    router.push({
      name: 'todomasterdetail',
      params: {
        todoMasterId: item.id,
      },
    })
  }

  // 新規案件登録画面に遷移
  const createTodoMaster = () => {
    // 案件詳細画面（新規作成モード）に遷移
    router.push({
      name: 'todomasterdetail',
      params: {
        todoMasterId: 'new',
      },
    })
  }

  // 戻るボタン
  const goBack = () => {
    // 案件一覧に戻る
    router.push({ name: 'todo' })
  }
</script>

<template>
  <Header />
  <main class="app-main">
    <div class="main-header">
      <button type="button" class="back" @click="goBack">
        <span class="material-symbols-outlined">arrow_back</span>
      </button>
      <h2>案件マスタ一覧</h2>

      <button type="button" class="new" @click="createTodoMaster">マスタ追加</button>

      <div class="filters">
        <!-- 検索ボックス -->
        <div class="search-box">
          <span class="material-symbols-outlined">search</span>
          <input type="search" v-model="searchText" placeholder="検索" />
        </div>

        <div class="search-result">
          {{ length }}
        </div>
      </div>
    </div>

    <div class="main-body">
      <DataTable :table-list="todoMasterStore.tableList" :data-list="todoMasterStore.todoMasters" :search-text="searchText" :sort-key="sortKey" :sort-desc="sortDesc" @select="editTodoMaster" @length="length = $event" />
    </div>
  </main>
  <Footer :breadcrumbs="breadcrumbs" />
</template>

<style lang="less" scoped>
  .material-symbols-outlined {
    vertical-align: middle;
  }
</style>
